import { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

/**
 * Provides keyboard offset for Android only.
 * iOS manages layout natively via setResizeMode.
 */
export function useAndroidKeyboardOffset() {
  const [keyboardOffset, setKeyboardOffset] = useState(0);

  useEffect(() => {
    if (Capacitor.getPlatform() !== "android") return;

    let showListener;
    let hideListener;

    const setupListeners = async () => {
      showListener = await Keyboard.addListener("keyboardWillShow", (info) => {
        console.log("Android keyboard showing", info.keyboardHeight);
        setKeyboardOffset(info.keyboardHeight || 300);
      });

      hideListener = await Keyboard.addListener("keyboardWillHide", () => {
        console.log("Android keyboard hiding");
        setKeyboardOffset(0);
      });
    };

    setupListeners();

    return () => {
      showListener?.remove();
      hideListener?.remove();
    };
  }, []);

  return keyboardOffset;
}
